import { Card } from "../../models/card";
import { cards } from "../../state";
import { Wood } from "../../cards/resources/wood";
import { AudioControl } from "../../audio";
import { dropCard, forceUpdate } from "../..";
export class Tree extends Card {
}
Tree.displayName = "Tree";
Tree.artUrl = "./assets/cards/tree.jpg";
Tree.effect = {
    callback: (card) => {
        let newPos = { x: card.position.x - 8, y: card.position.y - 180 };
        const newCard = new Wood(newPos);
        cards.push(newCard);
        forceUpdate();
        dropCard(newCard);
        AudioControl.wood.play();
        document.getElementById("recipes").classList.add("show");
    },
    description: "Take a Wood",
    needsFeedback: false,
};
